import React from 'react';
import { History } from 'lucide-react';

const pretty = (k) => String(k || '').replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// Read-only "Original Record" — what the Unscheduled Job said before the office remapped it.
// Reference only; shown only when it differs from the Visit's current canonical values.
export const OriginalRecordNote = ({ visit }) => {
  const o = visit?.original_record;
  if (!o) return null;
  const rows = [];
  if ((o.trade_id || '') !== (visit.department_id || '')) rows.push(['Trade', o.trade_name || (o.trade_id ? o.trade_id : 'Not set')]);
  if ((o.division || '') !== (visit.department || '')) rows.push(['Division', o.division ? pretty(o.division) : 'Not set']);
  if ((o.service_type || '') !== (visit.service_type || '')) rows.push(['Service Type', o.service_type || 'Not set']);
  if (!rows.length) return null;
  return (
    <div data-testid="visit-original-record" className="rounded-md border border-[#262626] bg-[#141414] px-3 py-2 text-xs">
      <p className="flex items-center gap-1 text-[10px] uppercase tracking-wider text-[#A3A3A3] font-bold mb-1">
        <History className="w-3 h-3" /> Original Record
      </p>
      {rows.map(([label, val]) => (
        <p key={label} data-testid={`visit-original-${label.toLowerCase().replace(' ', '-')}`} className="text-[#D4D4D4]">
          <span className="text-[#737373]">{label}:</span> {val}
        </p>
      ))}
    </div>
  );
};

export default OriginalRecordNote;
